var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"form"},[_c('h2',{staticClass:"h2"},[_vm._v("Вход в личный кабинет")]),_c('LoginForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }